import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/finally';

import { StatisticService } from '../../../../services/statistic.service';
import { UserService } from '../../../../services/user.service';
import { Statistic, Retailer } from '../../../../entities/index';
import { Log } from '../../../../utils/index';

@Component({
  selector: 'app-dashboard-groupedbydate',
  templateUrl: './dashboard-groupedbydate.html'
})
export class DashboardGroupedByDateComponent implements OnInit {
  stats: Observable<Statistic[]>;
  statType = 'activation';
  loading = false;
  retailerId: number = null;
  retailers: Promise<Retailer[]>;

  constructor(
    protected statisticService: StatisticService,
    protected userService: UserService
  ) {}

  @Log()
  ngOnInit() {
      this.watchCurrentUser();
  }

  @Log()
  watchCurrentUser() {
    this.userService.currentUser.subscribe(user => {
      if (user && user.id) {
        this.retailerId = user && user.role_retailer_id;
        this.loadStats();
      }
    });
  }

  loadStats() {
    this.loading = true;
    if (this.statType === 'activation') {
      this.stats = this.statisticService.activationStats(this.retailerId).finally(() => this.loading = false);
    } else if (this.statType === 'activation_still_active') {
      this.stats = this.statisticService.activationStillActiveStats(this.retailerId).finally(() => this.loading = false);
    } else if (this.statType === 'expired_no_subscription') {
      this.stats = this.statisticService.expiredNoSubscriptionStats(this.retailerId).finally(() => this.loading = false);
    } else if (this.statType === 'expired_with_subscription') {
      this.stats = this.statisticService.expiredWithSubscriptionStats(this.retailerId).finally(() => this.loading = false);
    }
  }

  @Log()
  changeStatType(statType: string = null) {
    this.statType = statType;
    this.loadStats();
  }

  @Log()
  filterRetailer(retailer: string) {
    this.retailerId = (retailer !== '') ? parseInt(retailer, 10) : null;
    this.loadStats();
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/dashboard/groupedbydate/dashboard-groupedbydate.component.ts